import React, {useState, useEffect, useRef} from 'react';
import {ContentDispatch} from 'framework';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {DynamicSelectField} from 'componentLibrary/form/DynamicSelectField';
import {Select} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import FemaGoModal from 'app-ui-componentlibrary/dist/go/components/common/modal/FemaGoModal';
import REST from 'go/requests/rest';
import {Popup, Loader, Dimmer} from 'semantic-ui-react';
import {checkWithinApplicationDeadlineWithGracePeriod} from 'common/utils';
import {withRouter} from 'react-router-dom';
import {getTaskIdForEntity} from 'go/components/dynamic/modules/grantLandingPage/utils';
import _ from 'lodash';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';

export const FundingOpportunityDropdownWrapper = (props) => {
  const {
    title,
    subApplication,
    fundingOpportunities,
    fundingOpportunityData,
    workflowActivityId,
    workflowTaskId,
    organizationId,
    confirmModal,
    ariaLabelledBy,
    id,
  } = props;

  const defaultOptions = fundingOpportunityData
    ? [
        {
          name: fundingOpportunityData.fundingOpportunityName,
          value: fundingOpportunityData.fundingOpportunityId,
          text: fundingOpportunityData.fundingOpportunityName,
        },
      ]
    : [];

  const [options, setOptions] = useState(defaultOptions);
  const [foIdGrantIdMap, setFoIdGrantIdMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [valueToSet, setValueToSet] = useState();
  const [isUpdatingEntities, setIsUpdatingEntities] = useState(false);

  useEffect(() => {
    getDropdownContents();
  }, []);

  const getDropdownContents = () => {
    const filteredFOs = _.filter(fundingOpportunities, (fundingOpportunity) => {
      const subappTypes = _.get(
        fundingOpportunity,
        'configData.subappConfig.sameOrgFilteredAppTypes',
        []
      );
      const subappType = +_.get(subApplication, 'payload.applicationType');
      return (
        checkWithinApplicationDeadlineWithGracePeriod(fundingOpportunity) &&
        _.includes(subappTypes, subappType)
      );
    });

    let applicationRequests = [];

    // Retrieve all applications for filtered FOs
    _.forEach(filteredFOs, (fundingOpportunity) => {
      const {fundingOpportunityId} = fundingOpportunity;
      applicationRequests.push(
        REST.dynamicData
          .getEntityByOrgIdAndFOId(organizationId, fundingOpportunityId, 'application')
          .then(REST.handler.handleResponse)
          .then((result) => {
            return {
              ...result,
              fundingOpportunity: fundingOpportunity,
            };
          })
      );
    });

    Promise.all(applicationRequests).then((applicationResults) => {
      const newFoIdGrantIdMap = _.cloneDeep(foIdGrantIdMap);
      const options = _.map(
        _.filter(applicationResults, (result) => {
          const application = _.get(result, '0');
          return !_.isEmpty(application);
        }),
        (filteredResult) => {
          const application = _.get(filteredResult, '0');
          const fundingOpportunity = filteredResult.fundingOpportunity;
          const {fundingOpportunityName, fundingOpportunityId} = fundingOpportunity;

          newFoIdGrantIdMap[fundingOpportunityId] = application.grantId;
          return {
            name: fundingOpportunityName,
            value: fundingOpportunityId,
            text: fundingOpportunityName,
          };
        }
      );
      setOptions(options);
      setFoIdGrantIdMap(newFoIdGrantIdMap);
      setLoading(false);
    });
  };

  const handleSelectChange = (currentValue, e) => {
    const newValue = +e.target.value;
    if (!_.isEqual(currentValue, newValue)) {
      if (confirmModal) {
        setShowConfirmationModal(true);
        setValueToSet(newValue);
      } else {
        handleModalConfirmAction(newValue);
      }
    }
  };

  const handleModalConfirmAction = async (value) => {
    setIsUpdatingEntities(true);
    setShowConfirmationModal(false);
    const {token, permissions} = props;
    const fundingOpportunityId = value;
    const fundingOpportunity = _.find(fundingOpportunities, (fundingOpportunity) => {
      return fundingOpportunity.fundingOpportunityId === fundingOpportunityId;
    });
    let updatedSubApp = {...subApplication};
    const programId = fundingOpportunity.programId;
    await REST.fundingOpportunity
      .getFundingOpportunity(token, fundingOpportunityId)
      .then((res) => {
        forceJsonResponse(res, MONO)
          .then((foResponse) => {
            const fundingOpportunityName = foResponse.fundingOpportunityName;
            const programName = foResponse.programName;

            let disasterInfo = '';
            if (foResponse.disasterNumber) {
              disasterInfo =
                foResponse.disasterNumber +
                ' ' +
                foResponse.declarationTypeCd +
                ' ' +
                foResponse.disasterStateCd;
            }

            updatedSubApp = {
              ...subApplication,
              disasterInfo,
              fundingOpportunityName,
              programName,
              fundingOpportunityId,
              programId,
            };
          })
          .then(async () => {
            try {
              await REST.dynamicData.updateEntity(token, updatedSubApp);
              if (workflowActivityId) {
                const {entityId} = subApplication;
                const data = {
                  workflowMessageName: `foChanged-${entityId}`,
                  variables: {
                    fundingOpportunityId,
                    programId,
                    contextId: fundingOpportunityId,
                    grantId: foIdGrantIdMap[fundingOpportunityId],
                  },
                };
                REST.workflow
                  .sendMessage(workflowActivityId, data)
                  .then((res) => {
                    getTaskIdForEntity(
                      token,
                      permissions,
                      entityId,
                      workflowTaskId,
                      30
                    ).then((taskId) => {
                      props.history.replace(`/tasks/${taskId}`);
                      props.saveManyEntityData(
                        ['runValidations', 'reloadTask'],
                        'data',
                        [true, true],
                        null
                      );
                    });
                  })
                  .catch((e) => {
                    setIsUpdatingEntities(false);
                    console.error('Error updating workflow task: ', e);
                  });
              }
            } catch (e) {
              setIsUpdatingEntities(false);
              console.error('Error updating subapplication: ', e);
            }
          });
      });
  };

  const value = subApplication.fundingOpportunityId;

  return (
    <Popup
      wide="very"
      content="Loading..."
      disabled={!loading}
      trigger={
        <div>
          {confirmModal && (
            <FemaGoModal
              title={confirmModal.title}
              type={confirmModal.type}
              open={showConfirmationModal}
              confirmAction={() => handleModalConfirmAction(valueToSet)}
              buttonText={confirmModal.action || 'Confirm'}
              cancelAction={() => setShowConfirmationModal(false)}
            >
              <p>{confirmModal.text}</p>
            </FemaGoModal>
          )}
          {isUpdatingEntities && (
            <Dimmer page={true} active>
              <Loader />
            </Dimmer>
          )}
          <Select
            id={id}
            options={options}
            value={value}
            label={title}
            disabled={loading}
            handleChange={(e) => handleSelectChange(value, e)}
            aria-labelledby={ariaLabelledBy || id}
            name={id}
          />
        </div>
      }
    />
  );
};

const FundingOpportunityDropdownWrapperWithRouter = withRouter(
  FundingOpportunityDropdownWrapper
);

export default connectDynamic(FundingOpportunityDropdownWrapperWithRouter);
